/**
 * Tenant app "Weinkeller Aufnahme" for MaisonVin TopOffer (CMS 668).
 * Discovered by admin-ui/src/apps/registry.js; nothing else registers it.
 * Domain documentation: api/src/docs/features/WINE_CELLAR_EVALUATION.md.
 */
const project = process.env.VUE_APP_PROJECT;

export default {
    key: 'wine-cellar-evaluation',
    extension: 'wine-cellar-evaluation',
    label: 'Weinkeller Aufnahme',
    icon: { name: 'wine-bottle', group: 'fas' },
    permissions: ['ex:shop', 'ex:shop:products'],
    routes: [
        {
            path: '/wine-cellar-evaluation',
            name: 'wine-cellar-evaluation',
            component: () => import('./views/List.vue'),
            meta: { title: `${project} Weinkeller Aufnahme` },
        },
    ],
};
